import React from 'react';
import { makeStyles } from '@mui/styles';

import {
  ListItemText
} from '@mui/material';


export default function ListItemTexts(props) {
  const classes = useStyles();

  return (
    <ListItemText
      primary={<span style={{ color: props.color, fontSize: '0.85rem' }}>{props.label}</span>}
      classes={{
        root: classes.root,
      }}
    />
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
  },
}));